import React from 'react';

import Select from 'react-select';

/** components */
import LabelWithTooltip from './LabelWithTooltip';

import ArrowDown from '../../assets/images/arrow-down.svg';

/** helpers */
import { validateInputField } from '../../helpers/validation';

const customStyles = {
  option: (provided, state) => ({
    ...provided,
    color: state.isSelected ? '#fff' : '#727272',
    fontFamily: "'Lato', sans-serif !important",
    fontWeight: 300,
    fontSize: 19,
    padding: 10,
  }),
  multiValueLabel: (styles, { data }) => ({
    ...styles,
    color: data.color,
    fontSize: '20px',
    cursor: 'pointer',
  }),
  multiValueRemove: (styles, { data }) => ({
    ...styles,
    color: data.color,
    cursor: 'pointer',
  }),
};

const MultipleSelect = ({
  data,
  setData,
  field,
  dataError,
  setDataError,
  fieldClassName,
  toggleFieldModal,
  isModalOpen,
  initializeSectionError,
}) => {
  const handleMultipleSelect = (value, name, field) => {
    initializeSectionError();
    if (value) {
      validateInputField(value, name, field, setDataError);
      setData({ ...data, [name]: value.map((item) => item.value) });
    } else {
      setData({ ...data, [name]: null });
    }
  };
  let selectedValues = [];
  if (data[field.name]) {
    selectedValues = field.options.filter((option) => data[field.name].includes(option.value));
  }

  return (
    <div key={field.name} className={fieldClassName}>
      <div className="form-field">
        <LabelWithTooltip
          field={field}
          toggleFieldModal={toggleFieldModal}
          isModalOpen={isModalOpen}
        />
        <div className="select-container">
          {selectedValues.length === 0 && (
            <div className="select-container__side-icon">
              <img src={ArrowDown} alt="down" />
            </div>
          )}
          <Select
            isMulti
            name={field.name}
            options={field.options}
            classNamePrefix="react-select"
            styles={customStyles}
            onChange={(value) => handleMultipleSelect(value, field.name, field)}
            getOptionLabel={(option) => option.label}
            getOptionValue={(option) => option.value}
            closeMenuOnSelect={false}
            value={selectedValues}
          />
        </div>
      </div>
      {dataError[field.name] && <p className="error-text">{dataError[field.name]}</p>}
    </div>
  );
};

export default MultipleSelect;
